'use client';

import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';

const data = [
  { vector: 'Brute Force', count: 1247, color: '#ef4444' },
  { vector: 'SQL Injection', count: 893, color: '#f97316' },
  { vector: 'Port Scan', count: 742, color: '#f59e0b' },
  { vector: 'Phishing C2', count: 534, color: '#e11d48' },
  { vector: 'XSS Attempt', count: 421, color: '#f97316' },
  { vector: 'DNS Tunneling', count: 318, color: '#a855f7' },
  { vector: 'MITM', count: 187, color: '#6366f1' },
  { vector: 'DoS/DDoS', count: 143, color: '#3b82f6' },
];

const CustomTooltip = ({ active, payload, label }: any) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-zinc-900 border border-zinc-700 rounded-lg px-3 py-2 shadow-xl text-xs">
      <p className="text-zinc-300 font-medium mb-1">{label}</p>
      <p className="text-zinc-400">Sayı: <span className="font-mono font-semibold text-zinc-200">{payload[0]?.value?.toLocaleString()}</span></p>
    </div>
  );
};

export default function AttackVectorChart() {
  return (
    <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-5">
      <div className="mb-4">
        <h3 className="text-sm font-semibold text-zinc-200">En Çok Kullanılan Saldırı Vektörleri</h3>
        <p className="text-xs text-zinc-500 mt-0.5">Bugün tespit edildi — tüm kaynaklar</p>
      </div>
      <ResponsiveContainer width="100%" height={200}>
        <BarChart data={data} layout="vertical" margin={{ top: 0, right: 8, left: 4, bottom: 0 }}>
          <CartesianGrid stroke="hsl(240 4% 14%)" strokeDasharray="3 3" horizontal={false} />
          <XAxis
            type="number"
            tick={{ fontSize: 10, fill: '#52525b', fontFamily: 'IBM Plex Mono' }}
            tickLine={false}
            axisLine={false}
            tickFormatter={(v) => v >= 1000 ? `${(v / 1000).toFixed(1)}k` : v}
          />
          <YAxis
            dataKey="vector"
            type="category"
            tick={{ fontSize: 10, fill: '#71717a' }}
            tickLine={false}
            axisLine={false}
            width={72}
          />
          <Tooltip content={<CustomTooltip />} />
          <Bar dataKey="count" radius={[0, 3, 3, 0]} barSize={14}>
            {data.map((entry, i) => (
              <Cell key={i} fill={entry.color} fillOpacity={0.8} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}